/* eslint-disable @typescript-eslint/no-var-requires */
export class Exception extends Error {
  constructor(message: string, handler: string) {
    Exception.persistException(message, handler);
    super(message);
  }

  static persistException(message, handler) {
    if (typeof window !== 'undefined') {
      // client side
      return;
    }

    // Only run on SSR
    const serializedException = `${JSON.stringify({message, handler})}`;
    const {writeFileSync} = require('fs');
    const staticValues = require('../../../config-static');

    writeFileSync(staticValues.buildFailureMessageFileName, serializedException);
  }
}
